// OAuth の scope 内部名 → 人間可読ラベル。同意画面（pages/oauth/Authorize.tsx）と
// マイページの「連携アプリ」一覧（pages/MyPage.tsx）で共通利用する。
// 未知の scope はそのまま表示する。
export const SCOPE_LABELS: Record<string, string> = {
  'read:animations': 'private を含むあなたのアップロードを読み取る',
  'read:favorites': 'あなたのお気に入り一覧を読み取る',
  'write:animations': 'あなたの名義で新しい VRMA をアップロード・投稿する',
  'write:favorites': 'あなたのお気に入りを追加・解除する',
};

export function scopeLabel(scope: string): string {
  return SCOPE_LABELS[scope] ?? scope;
}
